import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";
import layoutReducer from "@features/layout/layoutSlice";
import notificationReducer from "@features/modals/notificationModalSlice";
import genericModalReducer from "@features/modals/genericModalSlice";
import featureFlagsReducer from "@features/featureFlags/featureFlagsSlice";

import { getApiMiddlewares, getApiReducers } from "./apiHelper";

const apiMiddlewares = getApiMiddlewares();
const apiReducers = getApiReducers();
const rootReducer = combineReducers({
  layout: layoutReducer,
  notificationState: notificationReducer,
  genericModal: genericModalReducer,
  featureFlags: featureFlagsReducer,
  ...apiReducers,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    const middlewares = getDefaultMiddleware({
      immutableCheck: import.meta.env.NODE_ENV !== "development",
      serializableCheck: false,
    }).concat(apiMiddlewares);
    if (import.meta.env.NODE_ENV === "development") {
      middlewares.push(
        createLogger({
          collapsed: true,
          diff: true,
          duration: true,
        })
      );
    }
    return middlewares;
  },
  devTools: import.meta.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
